module.exports = __webpack_public_path__ + "static/media/msfes_logo.f2fcedd9.png";